import React from 'react';
import LeaderboardCard from '../Card';
import { useNavigate } from 'react-router-dom';

function LeaderboardCardsList({ cards = [] }) {
  const navigate = useNavigate();

  return (
    <div className='si-card__wrap'>
      {cards.map((card) => (
        <LeaderboardCard
          key={card?.quizid}
          heading={card?.title}
          bottomTitle={'Total Players'}
          bottomTitleValue={card?.totalplayer}
          btnText={'View leaderboard'}
          handleBtnClick={() =>
            navigate(`${card?.quizid}`, { state: { quizId: card?.quizid, isLbPage: true } })
          }
          rankings={card?.topranking}
        />
      ))}
    </div>
  );
}

export default LeaderboardCardsList;
